import { Stack } from 'canoe';
import React from 'react';

import { useGetAnalyticsQuery } from '@candu-ai/analytics/content-events';
import { QueryId, QueryParamUrlObject } from '@candu-ai/analytics/types';

import { ChartImpl } from './Chart';
import { Summary, SummaryPlaceholder } from './Summary';

interface LineGraphProps {
  queryId: QueryId;
  queryParams: QueryParamUrlObject;
  aggregateQueryId?: QueryId;
  unit?: '%';
  title: string;
  withTotalPrefix?: boolean;
  legend: string;
}

export const LineGraph = ({
  queryId,
  queryParams,
  aggregateQueryId,
  unit,
  title,
  withTotalPrefix,
  legend,
}: LineGraphProps) => {
  const [data, aggregateData, , isLoadingQuery] = useGetAnalyticsQuery<any>({
    queryId,
    queryParams,
    aggregateQueryId,
  });

  if (!isLoadingQuery && !data && !aggregateData) {
    // failed to fetch query
    return null;
  }

  return (
    <Stack spaceAfter="xl">
      {data && aggregateData && !isLoadingQuery ? (
        <Summary
          data={aggregateQueryId ? aggregateData : data}
          unit={unit}
          title={title}
          withTotalPrefix={withTotalPrefix}
        />
      ) : (
        <SummaryPlaceholder />
      )}
      <ChartImpl data={data} isLoadingQuery={isLoadingQuery} unit={unit} legend={legend} />
    </Stack>
  );
};
